import { SVGProps, Ref, forwardRef } from 'react';

export const GraduationHatFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path d="M7.998 1 0 5.617l7.998 4.618 7.998-4.618z" fill="currentColor" />
                <path
                    d="M2.333 9.072q0-.233.008-.487l5.657 3.266 5.667-3.271q.007.257.008.495c-.006 1.046-.07 2.483-.655 3.346-.263.388-.897.815-1.903 1.396-2.723 1.573-3.501 1.573-6.225 0-1.005-.58-1.64-1.008-1.902-1.396-.587-.864-.65-2.303-.655-3.35"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
GraduationHatFilledSize16Glyph.displayName = 'GraduationHatFilledSize16Glyph';
